exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.box-card[data-v-ed5e5b4e],\n.table[data-v-ed5e5b4e],\n.pag[data-v-ed5e5b4e] {\n  margin-top: 20px;\n}\n.el-col .el-button[data-v-ed5e5b4e]:nth-child(1),\n.el-col .el-button[data-v-ed5e5b4e]:nth-child(2) {\n  padding: 10px 14px;\n}\n", "", {"version":3,"sources":["/home/jenkins/agent/workspace/sunpay-system-manager-merchant/src/components/clientmanage/index.vue"],"names":[],"mappings":";AACA;;;EAGE,iBAAiB;CAClB;AACD;;EAEE,mBAAmB;CACpB","file":"index.vue","sourcesContent":["\n.box-card[data-v-ed5e5b4e],\n.table[data-v-ed5e5b4e],\n.pag[data-v-ed5e5b4e] {\n  margin-top: 20px;\n}\n.el-col .el-button[data-v-ed5e5b4e]:nth-child(1),\n.el-col .el-button[data-v-ed5e5b4e]:nth-child(2) {\n  padding: 10px 14px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ed5e5b4e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/clientmanage/index.vue
// module id = 65Y+
// module chunks = 1